import React, { Component } from "react";
import { Form, Text, Select, Option } from "informed";
import Data from "../App";
import { Primitives } from "../primitives";
import { first } from "rxjs/operators";

class AddUiView extends Component {
  constructor(props) {
    super(props);
    console.log("creating AddUiView");
    this.state = {};
    this.handleSave = this.handleSave.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.setFormApi = this.setFormApi.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    console.log("componentDidMount AddUiView " + this.props.templateType);
    const templateObs = Data.getInstance().getTemplatesBasic();
    this.subscription = templateObs.subscribe(templatesMap => {
      var template = templatesMap.get(this.props.templateType);
      console.log("new templatesMap " + JSON.stringify([...templatesMap]));
      console.log(
        "new template for prop: " +
          this.props.templateType +
          " => " +
          template.type
      );
      this.setState({ template: template });
    });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleSave(event) {
    //this.add();
    let ready = this.getObjectForCurrentEntries();
    if (ready) {
      this.setState({ completedType: ready });
      this.props.onSave(ready);
    }
  }

  getObjectForCurrentEntries() {
    let readyObject = {};
    readyObject.type = this.state.template.type;
    readyObject.refType = this.state.template.refType;
    const nameEntered = this.formApi.getState().values.name;
    console.log(
      JSON.stringify(this.formApi.getState().values) + "(" + nameEntered
    );
    for (let attrIndex in this.state.template.attributes) {
      let attr = this.state.template.attributes[attrIndex].attr;
      let value = this.formApi.getState().values[attr];
      console.log("ready attr: " + attr + " value: " + value);
      if (value === null || value === {} || value === "") return null;
      else {
        readyObject[attr] = value;
      }
    }
    console.log("readyObject: " + JSON.stringify(readyObject));
    return readyObject;
  }

  add() {
    const nameEntered = this.formApi.getState().values.name;
    console.log(
      JSON.stringify(this.formApi.getState().values) + "(" + nameEntered
    );
    if (nameEntered !== "") {
      const data = Data.getInstance();
      data.addUiComp(nameEntered, this.props.parentId);
      this.props.onClose();
    }
  }

  cancel() {
    this.props.onClose();
  }

  handleClose(event) {
    this.cancel();
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.add();
    } else if (event.key === "Escape") {
      //this.cancel();
    }
  }

  setFormApi(formApi) {
    this.formApi = formApi;
  }

  getStateOptions(rootState) {
    let options = [];
    options.push(<Option value={rootState.id}>{rootState.name}</Option>);
    if (rootState.childStates)
      options.push(
        rootState.childStates.map(state => this.getStateOptions(state))
      );
    return options;
  }

  renderEditing() {
    console.log("render for temp: " + this.state.template);
    var attributes = "";
    if (this.state.template && this.state.template.attributes) {
      console.log("render for attr: " + this.state.template.attributes);
      attributes = this.state.template.attributes.map(attr => {
        console.log("foudn attr " + attr.type);
        if (attr.type === "name" || attr.type === "label")
          return (
            <div>
              <Text
                className="ViewTitle"
                field={attr.attr}
                placeholder={attr.desc}
                autoFocus
                onKeyDown={this.handleKeyPress}
              />
            </div>
          );
        else if (attr.type === "text")
          return (
            <div>
              <Text
                className="InputText"
                field={attr.attr}
                placeholder={attr.desc}
                autoFocus
                onKeyDown={this.handleKeyPress}
              />
            </div>
          );
        else if (attr.type === "state" && attr.quant === "n?") {
          let stateOptions = "";
          if (this.props.vms) {
            stateOptions = this.props.vms
              .filter(vm => vm.rootState)
              .map(vm => this.getStateOptions(vm.rootState));
          }
          return (
            <div>
              <Select
                field={attr.attr}
                multiple
                style={{ height: "100px", width: "200px" }}
              >
                {stateOptions}
              </Select>
            </div>
          );
        } else if (Primitives.indexOf(attr.type) === -1)
          return (
            <AddUiView
              onClose={this.handleCloseClick}
              onSave={this.props.onSave}
              templateType={attr.type}
              vms={this.props.vms}
            />
          );
        else return "NONE";
      });
    }
    return (
      <div className="AddUiView">
        <Form getApi={this.setFormApi}>{attributes}</Form>
        <div className="AddUiViewConfirm" onClick={this.handleSave} />
        <div className="AddUiViewCancel" onClick={this.handleClose} />
      </div>
    );
  }

  renderCompleted() {
    if (this.state.template.type === "ui-binding")
      return <div className="UiBinding">{this.state.completedType.name}</div>;
    else if (this.state.template.type === "ui-action")
      return (
        <div className="UiAction">
          {this.state.completedType.name} ->
          {this.state.completedType.out[0].name}
        </div>
      );
    else if (this.state.template.type === "ui-single-reaction")
      return (
        <div className="UiSingleAction">{this.state.completedType.name}</div>
      );
  }

  render() {
    if (this.state.completedType) {
      return this.renderCompleted();
    } else {
      return this.renderEditing();
    }
  }
}
export default AddUiView;



// WEBPACK FOOTER //
// ./src/components/AddUiView.js